<template>
    <tr>
        <td class="col-customer">
            <router-link :to="{name: 'office.customers.show', params: {id: reminder.site.customer.id}}">
                {{ reminder.site.customer.company_name }}
            </router-link>
        </td>
        <td class="col-site">
            <router-link :to="{name: 'office.sites.edit', params: {customer_id: reminder.site.customer.id, id: reminder.site.id}}">
                {{ reminder.site.name }}
            </router-link>
            <span v-if="reminder.site.address">{{ reminder.site.address.postcode }}</span>
        </td>
        <td class="col-services">
            <strong>{{ reminder.nice_type }}</strong>
            <span v-if="reminder.type === 'fire_alarm' && reminder.site.fa_service_time"> ({{ reminder.site.fa_service_time }} hrs)</span>
            <span v-if="reminder.type === 'fire_ex' && reminder.site.fe_service_time"> ({{ reminder.site.fe_service_time }} hrs)</span>
            <span v-if="reminder.type === 'elighting' && reminder.site.elighting_service_time"> ({{ reminder.site.elighting_service_time }} hrs)</span>
            <span v-if="reminder.type === 'fire_risk_assessment' && reminder.site.ra_service_time"> ({{ reminder.site.ra_service_time }} hrs)</span>
        </td>
        <td class="col-contact">
            <a
                v-if="reminder.site.telephone"
                :href="'tel: ' + reminder.site.telephone"
            >{{ reminder.site.telephone }}</a>
            <a
                v-if="reminder.site.mobile_number"
                :href="'tel: ' + reminder.site.mobile_number"
            >{{ reminder.site.mobile_number }}</a>
            <a :href="'mailto: ' +reminder.site.email">{{ reminder.site.email }}</a>
            <a :href="'mailto: ' +reminder.site.customer.responsible_person_email">{{ reminder.site.customer.responsible_person_email }}</a>
        </td>
        <td class="col-month">
            {{ reminder.month_name }}
        </td>
        <td :class="'col-status service-reminder--'+reminder.status">
            <StatusComponent :reminder="reminder" />
        </td>
        <td class="text-center col-sent">
            <i
                v-if="reminder.sent"
                class="fa fa-check text-success"
                data-toggle="tooltip"
                data-placement="top"
                :title="'Sent at ' + formatDate(reminder.sent_at)"
            />
            <i
                v-else
                class="fa fa-times text-danger"
            />
        </td>
        <td class="col-notes">
            <input
                type="text"
                class="form-control"
                v-model="reminder.notes"
                placeholder="Notes..."
                v-debounce:500ms="notesChanged"
            >
        </td>
        <td class="col-actions">
            <button
                class="btn btn-info btn-sm"
                v-if="reminder.site && reminder.site.customer_id"
                @click.prevent="openComments()"
            >
                <i class="fa fa-comment" /> Comments
            </button>

            <button
                class="btn btn-info btn-sm"
                v-if="reminder.status === 'due'"
                :disabled="sending"
                @click.prevent="sendReminder(reminder)"
            >
                <i
                    v-show="!sending"
                    class="far fa-envelope"
                />
                <i
                    v-show="sending"
                    class="fa fa-sync-alt fa-spin"
                />
                Send reminder
            </button>
        </td>
    </tr>
</template>
<script>
import { mapMutations, mapActions, mapState } from "vuex";
import ServiceReminderService from "../../../services/ServiceReminderService";
import StatusComponent from "./StatusComponent.vue";

export default {
    components: {StatusComponent},
    props: {
        reminder: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState("serviceReminders", ["sending"]),
        lastCompletedAt() {
            return this.reminder.last_completed_at
                ? window.moment(this.reminder.last_completed_at)
                : null;
        },
    },
    methods: {
        ...mapMutations("comments", [
            "showModal",
            "setModalTitle",
            "loadComments",
        ]),
        ...mapMutations("comments", { setCommentsParams: "setParams" }),
        ...mapActions("serviceReminders", ["sendReminder"]),

        notesChanged() {
            ServiceReminderService.update(this.reminder).then((res) => {});
        },

        openComments() {
            const site = this.reminder.site;
            this.setCommentsParams({
                customerId: site.customer_id,
                siteId: site.id,
            });
            this.loadComments();
            this.setModalTitle(site.customer.company_name);
            this.showModal();
        },

        formatDate(date) {
            return date
                ? window.moment(date).format("DD/MM/YYYY HH:mm")
                : "Unknown";
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-reminders/RowComponent.vue